<!-- Licence Free for commercial use https://pixabay.com/photos/night-club-silhouette-party-club-1489132/ -->
<template>
  <v-container v-if="manager" fluid>
    <v-row>
      <v-col md="12">
        <v-card>

          <!--
            "Header" for the landing page
          -->

          <v-img dark height="200px"
              src="https://cdn.pixabay.com/photo/2016/06/30/14/55/night-club-1489132_960_720.jpg"
          >
            <v-row class="fill-height">
              <v-card-title class="white--text pl-12 pt-12">
                <div class="display-2 pl-12 pt-12">
                  {{ manager.name }}
                </div>
                <div class="display-1 pl-12 pt-12">
                  {{ manager.establishment }}
                </div>
              </v-card-title>
            </v-row>
          </v-img>

          <!--
            Alerts & Loaders
          -->
          <!--<Alerts :aType.sync="response"/>-->


          <!--
            Manager Info
          -->
          <v-list subheader two-line >
            <v-subheader>
              <p>
                Personal Data
              </p>
              <v-spacer></v-spacer>

              <!--
                Account settings
              -->
              <v-speed-dial v-model="fab" direction="left" right top transition="scale-transition">
                <template v-slot:activator>
                  <v-btn v-model="fab" color="blue darken-2" dark fab>
                    <v-icon v-if="fab">
                      mdi-close
                    </v-icon>
                    <v-icon v-else>
                      mdi-account-circle
                    </v-icon>
                  </v-btn>
                </template>

                <!--
                  Account settings sub-menu
                -->
                <v-row dense justify="end">
                  <v-col>
                    <div class="tooltip">
                      <v-btn class="mx-2 " dark fab large @click="editManager">
                        <v-icon dark>mdi-account-edit-outline</v-icon>
                      </v-btn>
                      <span class="tooltiptext">Edit Personal Data</span>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="tooltip">
                      <v-btn class="mx-2" dark fab large @click="editEmail">
                        <v-icon dark>mdi-email-edit-outline</v-icon>
                      </v-btn>
                      <span class="tooltiptext">Edit Email</span>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="tooltip">
                      <v-btn class="mx-2" dark fab large @click="editPassword">
                        <v-icon dark>mdi-shield-edit-outline</v-icon>
                      </v-btn>
                      <span class="tooltiptext">Edit Password</span>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="tooltip">
                      <v-btn class="mx-2" dark fab large color="red" @click="deleteAccount">
                        <v-icon dark>mdi-delete</v-icon>
                      </v-btn>
                      <span class="tooltiptext">Delete Account</span>
                    </div>
                  </v-col>
                </v-row>
              </v-speed-dial>
            </v-subheader>


            <!--
              Edit Manager
            -->
            <v-dialog v-model="dialogEditManager" persistent max-width="600px">
              <v-card>
                <v-card-title>
                  <span class="headline">Personal Data</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <div>
                          <v-text-field
                            v-model="editedManager.name"
                            label="Name"
                            required
                            @blur="$v.editedManager.name.$touch()"
                          ></v-text-field>
                          <p v-if="!$v.editedManager.name.maxLength" style="color: red;">Please provide a valid name within the range.</p>
                          <p v-if="$v.editedManager.name.$model === '' && !$v.editedManager.name.required" style="color: red;">Please provide a valid name.</p>
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <div>
                          <v-text-field
                            v-model="editedManager.address"
                            label="Address"
                            required
                            @blur="!$v.editedManager.address.$touch()"
                          ></v-text-field>
                          <p v-if="!$v.editedManager.address.maxLength || 
                            ($v.editedManager.address.$model === '' && !$v.editedManager.address.required)" 
                            style="color: red;">
                              Please provide a valid Address within the range.
                          </p>
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <div>
                          <v-text-field
                            v-model="editedManager.phone"
                            label="Telefone"
                            required
                            @blur="$v.editedManager.phone.$touch()"
                          ></v-text-field>
                          <p v-if="!$v.editedManager.phone.check_phone" style="color: red;">Phone number must start with 91,92,93 or 96.</p>
                          <p v-if="!$v.editedManager.phone.numeric" style="color: red;">Phone number must a numeric value.</p>
                          <p v-if="!$v.editedManager.phone.minLength || !$v.editedManager.phone.maxLength" style="color: red;">Phone number must have 9 digits.</p>
                          <p v-if="$v.editedManager.phone.$model === '' && !$v.editedManager.phone.required" style="color: red;">Please provide a valid phone number.</p>
                        </div>
                      </v-col>
                      <v-col cols="12">
                        <div>
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            min-width="290px"
                            offset-y
                            transition="scale-transition"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="dateFormatted"
                                v-bind="attrs"
                                v-on="on"
                                label="Birthdate"
                                prepend-icon="mdi-calendar"
                                readonly
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              ref="picker"
                              v-model="editedManager.birthdate"
                              :max="new Date(manager.birth).toISOString().substr(0, 10)"
                              min="1950-01-01"
                              @change="save"
                              @blur="$v.editedManager.birthdate.$touch()"
                            ></v-date-picker>
                          </v-menu>
                          <p v-if="!$v.editedManager.birthdate.minVal || !$v.editedManager.birthdate.maxVal" style="color: red;">You must be at least 18 years old to be a manager.</p>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeManager">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="saveManager" :disabled="$v.$anyError">Save</v-btn>
                </v-card-actions>
              </v-card>
              <Loader :loading="loadingCreateUpdateDelete"/>
            </v-dialog>

            <!--
              Edit Email
            -->
            <v-dialog v-model="dialogEmail" max-width="600px" persistent>
              <v-card>
                <v-card-title>
                  <span class="headline">Edit Email</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form>
                      <v-row>
                        <v-col cols="12" >
                          <div>
                            <v-text-field
                              v-model="newEmail"
                              label="Novo Email"
                              required
                              @blur="$v.newEmail.$touch()"
                            ></v-text-field>
                            <p v-if="!$v.newEmail.email || !$v.newEmail.wbst_suffix" style="color: red;">Please provide a valid email address.</p>
                          </div>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeEmailEditor">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="saveEmail" :disabled="$v.$anyError">Save</v-btn>
                </v-card-actions>
              </v-card>
              <Loader :loading="loadingCreateUpdateDelete"/>
            </v-dialog>

            <!--
              Edit Password
            -->
            <v-dialog v-model="dialogPassword" max-width="600px" persistent >
              <v-card>
                <v-card-title>
                  <span class="headline">Edit Password</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form>
                      <v-row>
                        <v-col cols="12">
                          <div>
                            <v-text-field
                              v-model="oldPassword"
                              label="Old Password"
                              required
                              @blur="$v.oldPassword.$touch()"
                            ></v-text-field>
                            <p v-if="!$v.oldPassword.minLength" style="color: red;">Passwords must be have at least 8 characters.</p>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <div>
                            <v-text-field
                              v-model="newPassword"
                              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="showPassword ? 'text' : 'password'"


                              label="New Password"
                              @click:append="showPassword = !showPassword"
                              @blur="$v.newPassword.$touch()"
                            ></v-text-field>
                            <p v-if="!$v.newPassword.minLength" style="color: red;">Passwords must be have at least 8 characters.</p>
                          </div> 
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          <div>
                            <v-text-field
                              v-model="newPasswordConfirm"
                              :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
                              :type="showPasswordConfirm ? 'text' : 'password'"


                              label="Confirm New Password"
                              @click:append="showPasswordConfirm = !showPasswordConfirm"
                              @blur="$v.newPasswordConfirm.$touch()"
                            ></v-text-field>
                            <p v-if="!$v.newPasswordConfirm.minLength" style="color: red;">Passwords must be have at least 8 characters.</p>
                            <p v-if="!$v.newPasswordConfirm.sameAs" style="color: red;">Passwords must be equal.</p>
                          </div>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closePasswordEditor">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="saveNewPassword" :disabled="$v.$anyError">Save</v-btn>
                </v-card-actions>
              </v-card>
              <Loader :loading="loadingCreateUpdateDelete"/>
            </v-dialog>

            <!--
              Delete Account
            -->
            <v-dialog v-model="dialogAccountDelete" max-width="600px" persistent>
              <v-card>
                <v-card-title>
                  <span class="headline">Are you sure you want to delete the account?</span>
                </v-card-title>
                <v-card-text></v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="closeAccountDelete">Cancel</v-btn>
                  <v-btn color="blue darken-1" text @click="deleteAccountConfirm">OK</v-btn>
                </v-card-actions>
              </v-card>
              <Loader :loading="loadingCreateUpdateDelete"/>
            </v-dialog>


            <!--
              Email Information Section
            -->
            <v-list-item>
              <v-list-item-icon>
                <v-icon>
                  mdi-email
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ manager.email }}</v-list-item-title>
                <v-list-item-subtitle>Email</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <!--
              Phone Information Section
            -->
            <v-list-item>
              <v-list-item-icon>
                <v-icon>
                  mdi-phone
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ manager.phone }}</v-list-item-title>
                <v-list-item-subtitle>Phone Number</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <!--
              Address Information Section
            -->
            <v-list-item>
              <v-list-item-icon>
                <v-icon>
                  mdi-map-marker
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ manager.address }}</v-list-item-title>
                <v-list-item-subtitle>Address</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <!--
              BirthDay Information Section
            -->
            <v-list-item>
              <v-list-item-icon>
                <v-icon>
                  mdi-cake
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ manager.birth | dateFormat }}</v-list-item-title>
                <v-list-item-subtitle>Birthdate</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>


          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import moment from "moment";
import {
  manager_delete,
  manager_get,
  manager_update,
  manager_update_email,
  manager_update_password
} from "../../modules/nite_api";

import { required,email,helpers,minLength,maxLength,numeric,sameAs } from 'vuelidate/lib/validators';
import Loader from "../shared/Loader"
import VueNotifications from "vue-notifications";

//Check if email contains .com or .net
const wbst_suffix = helpers.regex('alpha',/(\.com|\.net)$/);

//Check if the phone number start with 91,92,93,96 and has 9 elements
const check_phone = helpers.regex('numeric', /^(91|92|93|96)/);

export default {
  name: "ManagerArea",
  components: {
    Loader
  },
  data: () => ({
    response: null,
    loadingCreateUpdateDelete: false,
    fab: false,
    newPassword: '',
    newPasswordConfirm: '',
    oldPassword: '',
    newEmail: '',
    showPassword: false,
    showPasswordConfirm: false,
    editedManager: {
      address: "",
      establishment: "",
      phone: "",
      name: "",
      birthdate: null
    },
    defaultManager: {
      address: "",
      establishment: "",
      phone: "",
      name: "",
      birthdate: null
    },
    menu: false,
    dialogEditManager: false,
    dialogEmail: false,
    dialogPassword: false,
    dialogAccountDelete: false,
  }),
  validations: {
    newEmail: {
      required,
      email,
      wbst_suffix
    },
    defaultManager: {
      phone: {
        required,
        numeric,
        check_phone,
        minLength: minLength(9),
        maxLength: maxLength(9)
      },
      name: {
        required,
        maxLength: maxLength(45),
        
      },
      birthdate: {
        required,
        minVal: value => value >= '1950-01-01',
        maxVal: value => value <= '2002-12-31'
      },
      address: {
        required,
        maxLength: maxLength(100)
      },
      establishment: {
        required
      }
    },
    editedManager: {
      phone: {
        required,
        numeric,
        check_phone,
        minLength: minLength(9),
        maxLength: maxLength(9)
      },
      name: {
        required,
        maxLength: maxLength(45),
        
      },
      birthdate: {
        required,
        minVal: value => value >= '1950-01-01',
        maxVal: value => value <= '2002-12-31'
      },
      address: {
        required,
        maxLength: maxLength(100)
      },
      establishment: {
        required
      }
    },
    newPasswordConfirm: {
      required,
      minLength: minLength(8),
      sameAs: sameAs('newPassword')
    },
    newPassword: {
      required,
      minLength: minLength(8)
    },
    oldPassword: {
      required,
      minLength: minLength(8)
    },
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    dateFormatted(val) {
      val || this.editedManager.birthdate ? moment(this.editedManager.birthdate).format('DD-MM-YYYY') : ''
    },

  },
  methods: {


    ...mapMutations({

      setManager: 'auth/SET_USER',
      setToken: 'auth/SET_TOKEN',
      setRefreshToken: 'auth/SET_REFRESH_TOKEN'


    }),
    async refreshManager() {
      this.loadingCreateUpdateDelete = true;
      try {
        const response = await manager_get()
        // Success
        console.log(response);

        this.setManager(response.data)
      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      } finally {
        this.loadingCreateUpdateDelete = false;
        switch (this.response) {
          case 200:

            break;

          case 400:
            this.showErrorMsg({
              title: 'Oops',
              message: 'The manager doesn\'t exist!'
            });
            break;
          case 401:
            this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
            break;
          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }
      }


    },
    async saveManager() {


      let data = {
        "address": this.editedManager.address,
        "birth": this.editedManager.birthdate,
        "establishment": this.editedManager.establishment,
        "name": this.editedManager.name,
        "phone": this.editedManager.phone
      }

      this.loadingCreateUpdateDelete = true;
      try {
        const response = await manager_update(data);
        // Success
        console.log(response);
        this.response = response.status;

      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      } finally {
        this.loadingCreateUpdateDelete = false;
        switch (this.response) {
          case 200:
            this.showSuccessMsg({title: 'Success', message: 'Personal data updated successfully!'});
            break;
          case 304:
            this.showWarnMsg({title: 'Oops', message: 'You didn\'t update nothing!'});
            break;
          case 400:
            this.showErrorMsg({
              title: 'Oops',
              message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
            });
            break;
          case 401:
            this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
            break;

          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }

      }
      await this.closeManager()
    },
    async saveEmail() {
      let data = {"email": this.newEmail}
      this.loadingCreateUpdateDelete = true;
      try {
        const response = await manager_update_email(data)
        // Success
        console.log(response);
        this.response = response.status;

      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          this.response = 400;
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
          this.response = 500;
        }
        console.log(error);
      } finally {
        this.loadingCreateUpdateDelete = false;
        switch (this.response) {
          case 200:
            this.showSuccessMsg({title: 'Success', message: 'Email updated successfully!'});
            break;
          case 304:
            this.showWarnMsg({title: 'Oops', message: 'You didn\'t update your email!'});
            break;
          case 400:
            this.showErrorMsg({
              title: 'Oops',
              message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
            });
            break;
          case 401:
            this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
            break;
          case 404:
            this.showErrorMsg({title: 'Oops', message: 'The resource doesn\'t exist! Please try again!'});
            break;
          case 409:
            this.showErrorMsg({
              title: 'Oops',
              message: 'The email that you trying to add already exists! Please try again with other email!'
            });
            break;
          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }

      }


      await this.closeEmailEditor()
    },
    async saveNewPassword() {


      // data = { "newPassword": "123admin", "oldPassword": "1234admin" }

      let data = {"newPassword": this.newPassword, "oldPassword": this.oldPassword}

      this.loadingCreateUpdateDelete = true;
      try {
        const response = await manager_update_password(data)
        // Success
        this.response = response.status;

      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error);
      } finally {
        this.loadingCreateUpdateDelete = false;
        switch (this.response) {
          case 200:
            this.showSuccessMsg({title: 'Success', message: 'Password updated successfully!'});
            break;
          case 304:
            this.showWarnMsg({title: 'Oops', message: 'You didn\'t update your password!'});
            break;
          case 400:
            this.showErrorMsg({
              title: 'Oops',
              message: 'Some field is missing or isn\'t correct. Please make the corrections and try again!'
            });
            break;
          case 401:
            this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
            break;
          case 404:
            this.showErrorMsg({title: 'Oops', message: 'The resource doesn\'t exist! Please try again!'});
            break;
          case 409:
            this.showErrorMsg({
              title: 'Oops',
              message: 'The employee email that you trying to add already exists! Please try again with other email!'
            });
            break;
          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }

      }

      this.closePasswordEditor()
    },
    async deleteAccountConfirm() {
      this.loadingCreateUpdateDelete = true;
      try {
        const response = await manager_delete()
        // Success
        console.log(response);
        this.response = response.status;

        this.setManager(null);
        this.setToken(null)
        this.setRefreshToken(null)
        await this.$router.push('/sign-in')
      } catch (error) {
        // Error
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          console.log(error.response.data);
          console.log(error.response.status);
          this.response = error.response.status;

          console.log(error.response.headers);
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
        } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      } finally {
        this.loadingCreateUpdateDelete = false;
        switch (this.response) {
          case 200:
            this.showSuccessMsg({title: 'Success', message: 'Account deleted successfully!'});
            break;

          case 401:
            this.showErrorMsg({title: 'Error', message: 'You aren\'t authorized to do that operation!'});
            break;
          case 500:
            this.showErrorMsg({
              title: 'Error',
              message: 'Something went wrong with the request. Please try again later!'
            });
            break;
          default:
            break;
        }

      }
      this.closeAccountDelete()
    },
    async closeManager() {
      this.dialogEditManager = false;
      this.$nextTick(() => {
        this.editedManager = Object.assign({}, this.defaultManager)
        this.$v.$reset();

      })
      await this.refreshManager()
    },
    async closeEmailEditor() {
      this.dialogEmail = false

      this.$nextTick(() => {
        this.newEmail = ''
        this.$v.$reset();
      })
      await this.refreshManager()
    },
    closePasswordEditor() {
      this.dialogPassword = false
      this.$nextTick(() => {
        this.newPassword = ''
        this.oldPassword = ''
        this.newPasswordConfirm = ''
        this.$v.$reset();

      })

    },
    closeAccountDelete() {
      this.dialogAccountDelete = false
      this.$nextTick(() => {
        this.editedManager = Object.assign({}, this.defaultManager)

      })
    },
    editEmail() {
      this.dialogEmail = true

    },
    editPassword() {
      this.dialogPassword = true
    },
    editManager() {

      this.editedManager.address = this.manager.address;
      this.editedManager.establishment = this.manager.establishment;
      this.editedManager.phone = this.manager.phone;
      this.editedManager.name = this.manager.name;
      this.editedManager.birthdate = new Date(this.manager.birth).toISOString().substr(0, 10)

      this.dialogEditManager = true;

    },
    deleteAccount() {


      this.dialogAccountDelete = true
    },
    save(date) {
      this.$refs.menu.save(date);
    },
  },

  computed: {
    ...mapGetters({
      manager: "auth/manager",
    }),
    dateFormatted() {
      return this.editedManager.birthdate ? moment(this.editedManager.birthdate).format('DD-MM-YYYY') : ''
    },

  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: 'Hello there',
      message: 'That\'s the success!'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Hey you',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Wow, man',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: 'Wow-wow',
      message: 'That\'s the error'
    }


}};
</script>

<style scoped>
/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;

}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50%;
  margin-left: -60px; /* Use half of the width (120/2 = 60), to center the tooltip */
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
}

.tooltip .tooltiptext::after {
  content: " ";
  position: absolute;
  bottom: 100%; /* At the top of the tooltip */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}
</style>
